<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Norm-Center" id="auto_bookmark_table_of_contents_1"><span>To the people who got me through quarantine on audio—I feel blessed to know you all in person: Mary Calmes, Melinda Leigh, Karen Rose. Your words are magic, and they saved my life. Also Mate. Because we went a little nuts together.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?63ae172f